module.exports = __webpack_public_path__ + "static/media/599.756(3).270122af.pdf";